<template>
  <div>
    <!-- view issue -->
    <div class="col-12">
      <div v-if="issue">

        <div class="row issue-detail-section" v-if="issue.referenceId">
          <div class="col-12 col-md-12">
            <h6>Reference ID</h6>
          </div>
          <div class="col-12 col-md-12">
            {{issue.referenceId}}
          </div>
        </div>

        <div class="row issue-detail-section">
          <div class="col-12 col-md-12">
            <h6>Title</h6>
          </div>
          <div class="col-12 col-md-12">
            {{issue.title}}
          </div>
        </div>

        <div class="row issue-detail-section" v-if="issue.description">
          <div class="col-12 col-md-12">
            <h6>Description</h6>
          </div>
          <div class="col-12 col-md-12">
            {{issue.description}}
          </div>
        </div>

        <!-- Attachments -->
        <div class="row issue-detail-section" v-if="issue.attachments && issue.attachments.length > 0">
          <div class="col-12">
            <h6>{{ $t("message.Attachments") }}</h6>
          </div>

          <div style="width: 100%">
            <div class="row">
              <div class="col-4" v-for="(attachment,index) in issue.attachments" :key="index">
                <card class="h-100">
                  <div class="row justify-content-center">
                    <!-- Thumbnail -->
                    <div class="col-12" @click="viewFile(attachment)">
                      <dynamic-image v-if="attachment.type.indexOf('image') > -1" :file-id="attachment.fileId">
                      </dynamic-image>
                      <dynamic-video v-if="attachment.type.includes('video/')" :file-id="attachment.fileId" class="sc-video" controlsList="nodownload" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; width: 100%" :options="{controls: false}" />
                      <i class="fa fa-file-pdf-o" style="font-size: 2em" v-if="attachment.type.indexOf('pdf') > -1"></i>
                    </div>
                    <!-- <div @click="viewFile(attachment)" class="col-8" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;margin: auto;">
                    {{ attachment.name }}
                    </div> -->
                  </div>
                </card>
              </div>
            </div>
          </div>
        </div>

        <!-- Status Timeline-->
        <div class="row issue-detail-section">
          <div class="col-md-12 ">
            <h6> Issue status</h6>
          </div>
          <div class="col-md-12">
            <el-timeline>
              <el-timeline-item v-for="(status, index) in issue.statusHistory" size='large' :key="index" icon="el-icon-check" :timestamp="getFormatedDatetime(status.timestamp)">
                {{status.status}}
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>

        <div class="row issue-detail-section comments" v-if="comments && comments.length > 0">
          <div class="col-md-12 ">
            <h6>Comments</h6>
          </div>
          <div class="col-md-12">
            <card v-for="comment in comments" :key="comment._id">
              <div class="col-12" style="font-size: 14px;line-height: 1.3em;">
                {{comment.comment}}
              </div>
              <div class="col-12" style="font-size: 11px;color: #909399;margin-top: 0.5em;">
                <span style="margin-inline-end: 2em;"> {{comment.user.firstName}} {{comment.user.lastName}} </span>
                <span>{{getFormatedDatetime(comment.timestamp)}}</span>
              </div>
            </card>
          </div>
        </div>

      </div>

    </div>

    <modal :show.sync="PREVIEW_FILE" headerclasses="justify-content-center" v-if="fileToPreview">
      <h6 slot="header" class="title title-up">File Preview</h6>

      <card>
        <div class="row justify-content-center">
          <!-- Thumbnail -->
          <div class="col-12 pr-0">
            <dynamic-image v-if="fileToPreview.type.indexOf('image') > -1" :file-id="fileToPreview.fileId">
            </dynamic-image>
            <dynamic-video v-if="fileToPreview.type.includes('video/')" :file-id="fileToPreview.fileId" class="sc-video" controlsList="nodownload" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; width: 100%" :options="{controls: true}" />
            <!-- <i class="fa fa-file-pdf-o" style="font-size: 2em" v-if="attachment.type.indexOf('pdf') > -1"></i> -->
          </div>
        </div>
      </card>
    </modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      issue: null,
      PREVIEW_FILE: false,
      fileToPreview: null,
    };
  },

  async mounted() {
    console.log("on view issue page ...");
    this.issue = await this.$store.dispatch(
      "getIssue",
      this.$route.params.issueId
    );
    console.log("issue response : ", this.issue);
  },
  methods: {
    getFormatedDatetime(timestamp) {
      return moment(Number(timestamp)).format("DD-MM-YYYY, h:mm a");
    },

    viewFile(file) {
      this.fileToPreview = file;
      this.PREVIEW_FILE = true;
    },
  },
  computed: {
    comments() {
      if (this.issue && this.issue.comments) {
        let comments = this.issue.comments.filter(
          (comment) => comment.type == "public" && comment.comment
        );
        return comments;
      } else {
        return [];
      }
    },
  },
};
</script>


<style scoped>
.issue-detail-section {
  margin-top: 2em;
}

/deep/.el-timeline-item__icon {
  color: #18ce0f;
}

/deep/.el-timeline-item__node {
  background: white;
  border: solid 1px #18ce0f;
  padding: 0.8em;
  left: -7px;
}
/deep/.el-timeline-item {
  padding-bottom: 30px;
}

/deep/.el-timeline-item__timestamp {
  font-size: 11px;
}

/deep/ .comments .card-body {
  padding: 15px;
}
</style>

